import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import {
  Grid,
  Card,
  Header,
  Item,
  Loader,
  Menu,
  Dropdown,
  Radio,
  Input,
  Button,
  Icon,
} from 'semantic-ui-react';
import {
  API_ORG_PROGRAM_GET_SUCCESS,
  API_PROGRAM_LIST_GET_SUCCESS,
  API_SUBORG_ORG_PROGRAM_GET_SUCCESS,
} from 'common/types';
import {isSubAOR} from 'go/security/permissions';
import {ENTITY_MAP, ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {
  RFA_TYPE_LIST,
  RFA_PROG_LIST,
  RFA_COMPLETED_STATUSES,
} from 'go/components/rfa/constants';
import ApiActions from 'go/actions/api';
import {ISOToDisplayDate} from 'common/utils';
import _ from 'lodash';
import moment from 'moment';
import {Toggle, Alert} from 'componentLibrary';

const NEW_SUBORG_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.SUBAUTHREP.code,
  ROLE_MAP.SUBMEMBER.code,
];

const NEW_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.ORGAOR.code,
  ROLE_MAP.ORGMEMBER.code,
  ROLE_MAP.ORGPGMMEMBER.code,
  ROLE_MAP.ORGGRNTWRITER.code,
  ROLE_MAP.ORGFINMEMBER.code,
];

export class ApplyNewGrantCardSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      programs: [],
      activeItem: 'Application period',
      sortingDirection: 'Descending',
      rfas: [],
      searchTerm: '',
    };

    this.permObj = _.reduce(
      props.permissions,
      (result, permission) => {
        const [entityTypeId, orgRelationship, roleId] = permission.split(':');
        if (_.indexOf(result.types, entityTypeId) === -1) {
          result.entityTypes.push(entityTypeId);
        }
        if (_.indexOf(result.orgRelationship, orgRelationship) === -1) {
          result.orgRelationship.push(orgRelationship);
        }
        if (_.indexOf(result.roles, roleId) === -1) {
          result.roles.push(roleId);
        }
        return result;
      },
      {entityTypes: [], orgRelationship: [], roles: []}
    );
  }

  refreshData() {
    const {
      token,
      getOrgPrograms,
      getProgramInfo,
      getSuborgOrgPrograms,
      userOrgs,
    } = this.props;

    const samGovOrgs = _.filter(userOrgs, (org) => org.isManuallyAdded === 'N');

    let parentOrgs = [];
    let programIds = [];
    let subOrgs = [];
    let rfaProg = [];
    let rfaParents = [];

    _.forEach(this.permObj.orgRelationship, (orgRel) => {
      const [orgId, progId, subOrgId] = orgRel.split('_');
      parentOrgs.push(orgId);
      programIds.push(progId);
      subOrgs.push(subOrgId);

      //Checking permissions for starting a request for assistance (RFA)
      if (RFA_PROG_LIST.includes(Number(progId))) {
        if (orgId == subOrgId) rfaProg.push(Number(progId));

        if (!rfaParents.includes(orgId) && orgId)
          rfaParents.push({
            programId: Number(progId),
            organizationId: Number(orgId),
            subOrganizationId: Number(subOrgId),
          });
      }
    });

    const isNewGrantAllowedForRole =
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0;
    const isNewSubOrgGrantAllowedForRole =
      _.intersection(NEW_SUBORG_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0;
    if (
      _.intersection(this.permObj.entityTypes, [
        ENTITY_MAP.PROGRAM_ORGANIZATION.code,
        ENTITY_MAP.ORGANIZATION.code,
      ])
    ) {
      getOrgPrograms(token)
        .then((res) => {
          if (res && res.hasResults) {
            const programs = res.payload.organizationPrograms;
            const ids = new Set(_.map(programs, 'programId'));

            // filter out sub-organization permissions, and filter out non-SamGov orgs (that do not have a programId)
            let orgProgram = [];
            if (!isNewSubOrgGrantAllowedForRole && isNewGrantAllowedForRole) {
              _.filter(programs, (program) => {
                if (!_.has(program, 'parentOrganizations')) {
                  orgProgram.push({
                    orgId: program.organizationId,
                    programId: program.programId,
                  });
                }
              });
            } else if (!isNewGrantAllowedForRole && isNewSubOrgGrantAllowedForRole) {
              _.filter(programs, (program) => {
                if (_.has(program, 'parentOrganizations')) {
                  for (let i = 0; i < subOrgs.length; i++) {
                    const subOrg = subOrgs[i];
                    if (
                      subOrg == program.organization.organizationId &&
                      parentOrgs[i] == program.parentOrganizations[0].organizationId &&
                      programIds[i] == program.programId
                    ) {
                      orgProgram.push({
                        orgId: program.organization.organizationId,
                        programId: program.programId,
                      });
                    }
                  }
                }
              });
            } else {
              _.forEach(programs, (program) => {
                if (_.has(program, 'parentOrganizations')) {
                  for (let i = 0; i < subOrgs.length; i++) {
                    const subOrg = subOrgs[i];
                    if (
                      subOrg == program.organization.organizationId &&
                      parentOrgs[i] == program.parentOrganizations[0].organizationId &&
                      programIds[i] == program.programId
                    ) {
                      orgProgram.push({
                        subOnly:
                          program.parentOrganizations[0].organizationId !==
                          program.organization.organizationId,
                        orgId: program.organization.organizationId,
                        programId: program.programId,
                      });
                    }
                  }
                } else {
                  orgProgram.push({
                    orgId: program.organizationId,
                    programId: program.programId,
                  });
                }
              });
            }
            const params = Array.from(ids).toString();

            return getProgramInfo(token, params).then((res) => {
              if (res) {
                const programs = res.payload;
                this.setState({
                  loading: false,
                  programs,
                  allOrgPrograms: res.payload,
                  orgProgram,
                  rfaProg,
                });
              }
            });
          } else {
            this.setState({loading: false});
          }
        })
        .then(() => {
          // Check the permissions

          if (!isNewGrantAllowedForRole && !isNewSubOrgGrantAllowedForRole) {
            return Promise.resolve();
          }
          const {token} = this.props;
          const {orgProgram} = this.state;

          // Get funding opportunity for program
          // Remove program(s) if they belong ONLY not SamGov organization
          const samGovOrgsIds = _.map(samGovOrgs, 'organizationId');

          let programIds = _.chain(orgProgram).map('programId').uniq().value();

          const requests = _.map(programIds, (programId) =>
            REST.fundingOpportunity.getFundingOpportunitiesForProgram(token, programId)
          );
          return Promise.all(requests);
        })
        .then((foResponses) => Promise.all(_.map(foResponses, (resp) => resp.json())))
        .then((respJson) => {
          const fundingOpportunities = _.chain(respJson)
            // TODO: Result/payload wrapper clean up
            .map('payload')
            .map((resp) => JSON.parse(resp))
            .map('fundingOpportunities')
            .flatten()
            .value();
          return this.setState({fundingOpportunities});
        })
        .then(() => {
          const {fundingOpportunities} = this.state;
          let rfaRequests = [];

          const filteredFOs = fundingOpportunities.filter(
            (fo) => fo.configData?.disasterFOOverview?.needAnApprovedReqForAssistance
          );
          _.forEach(filteredFOs, (fo) => {
            _.forEach(rfaParents, (parent) => {
              if (parent.programId == fo.programId && !isNaN(parent.subOrganizationId)) {
                rfaRequests.push(
                  REST.dynamicData.getRfaStatusBySubOrganizationOrganizationFo({
                    subOrgId: parent.subOrganizationId,
                    orgId: parent.organizationId,
                    foId: fo.fundingOpportunityId,
                  })
                );
              }
            });
          });

          return Promise.all(rfaRequests)
            .then((rfaResponses) => {
              return Promise.all(_.map(rfaResponses, (rfaRes) => rfaRes.json()));
            })
            .then((rfaJson) => {
              const rfaData = _.chain(rfaJson).map('rfa').flatten().value();

              this.setState({
                rfas: rfaData,
              });

              return;
            })
            .catch((err) => {
              console.error('Request for rfa data failed.', err);
              this.setState({
                rfas: [],
              });
            });
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.userOrgs, this.props.userOrgs)) {
      this.refreshData();
    }
  }

  componentDidMount() {
    const {userOrgs} = this.props;
    if (userOrgs) {
      this.refreshData();
    }
  }

  renderObjects(objects) {
    if (objects.length) {
      return (
        <Item.Group divided>
          {_.map(objects, (obj) => {
            return (
              <Item key={obj.id} className="homepage">
                <Item.Content>
                  {_.includes(this.props.toggles, 'fmagEnhancePt1') ? (
                    <h4 style={{marginBottom: 0, marginTop: 0}}>{obj.programName}</h4>
                  ) : (
                    <></>
                  )}
                  <h4 style={{marginBottom: 0, marginTop: 4}}>{obj.displayName}</h4>
                  <div>
                    {obj.aplcnStartDate && obj.aplcnEndDate ? (
                      <>
                        Application period:{' '}
                        <span className="homepage-details">
                          {ISOToDisplayDate(obj.aplcnStartDate, {
                            showDate: true,
                            showHours: false,
                          })}{' '}
                          -{' '}
                          {ISOToDisplayDate(obj.aplcnEndDate, {
                            showDate: true,
                            showHours: false,
                          })}{' '}
                        </span>
                      </>
                    ) : (
                      <>
                        Application period:{' '}
                        <span className="homepage-details">Not available</span>
                      </>
                    )}
                    {obj.link ? (
                      <>
                        <br />
                        <Link
                          id={'startLink' + obj.id}
                          to={obj.link}
                          title={`${obj.linkDisplay} ${obj.displayName}`}
                        >
                          {obj.linkDisplay}
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                    {obj.rfaLink ? (
                      <>
                        <br />
                        <Link
                          id={'startRfaLink' + obj.id}
                          to={obj.rfaLink}
                          title={`${obj.rfaLinkDisplay} ${obj.displayName}`}
                        >
                          {obj.rfaLinkDisplay}
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                    {obj.subLink ? (
                      <>
                        <br />
                        <Link
                          id={'startSubLink' + obj.id}
                          to={obj.subLink}
                          title={`${obj.subLinkDisplay} ${obj.displayName}`}
                        >
                          {obj.subLinkDisplay}
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Item.Content>
              </Item>
            );
          })}
        </Item.Group>
      );
    } else if (objects.length == 0 && this.state.searchTerm) {
      return (
        <Alert header="No search results found" type="info">
          <p>Please try a different search criteria.</p>
        </Alert>
      );
    }
  }

  handleItemClick = (e, {name}) => this.setState({activeItem: name});

  handleDirectionChange = (e, {value}) => {
    this.setState({sortingDirection: value});
  };

  onSubmit = (e) => {
    e.preventDefault();
  };

  handleTermChange = (e, entry) => {
    this.setState({searchTerm: entry.value});
  };

  render() {
    const {
      loading,
      fundingOpportunities,
      activeItem,
      sortingDirection,
      programs,
      orgProgram,
      rfaProg,
      rfas,
      searchTerm,
    } = this.state;

    const isNewGrantAllowedForRole =
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0;
    const isNewSubOrgGrantAllowedForRole =
      _.intersection(NEW_SUBORG_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0;

    // Creating array of objects for rendering
    let objectsToRender = [];
    let filteredObjects = [];
    _.each(fundingOpportunities, (fo, index) => {
      const progCategoryId = _.get(
        _.find(programs, (program) => program.programId == fo.programId),
        'programCategoryId'
      );
      const programName = _.get(
        _.find(programs, (program) => program.programId == fo.programId),
        'programName'
      );

      const subAppFlag =
        isNewSubOrgGrantAllowedForRole &&
        _.get(
          _.find(programs, (program) => program.programId == fo.programId),
          'subapplicationFlag'
        ) &&
        _.find(this.permObj.orgRelationship, (orgRel) => {
          const progId = orgRel.split('_')[1];
          return progId == fo.programId;
        });

      const subOnly = _.get(
        _.find(orgProgram, (program) => program.programId == fo.programId),
        'subOnly'
      );
      const canStartApplication = isNewGrantAllowedForRole && !subOnly;

      let subAppLocation;
      if (
        _.get(
          _.find(programs, (program) => program.programId == fo.programId),
          'configPath'
        ) === 'passthrough/0'
      ) {
        subAppLocation = `/subApplicationInitialize/${progCategoryId}`;
      } else {
        subAppLocation = `/subApplicationInitialize/fo/${fo.fundingOpportunityId}`;
      }

      let rfaLocation = `/rfaInitialize/fo/${fo.fundingOpportunityId}`;

      let assist, hasValidAssist, canStartRfa, needsRfaApproval, completedRFA;
      if (!_.isEmpty(fo.configData)) {
        assist = fo.configData?.disasterFOOverview?.typeOfRequestForAssistance;
        hasValidAssist = assist != undefined && RFA_TYPE_LIST.includes(assist);
        canStartRfa = hasValidAssist && rfaProg.includes(fo.programId);

        needsRfaApproval =
          fo.configData?.disasterFOOverview?.needAnApprovedReqForAssistance;

        const rfa = rfas.find(
          (r) => _.get(r, 'fundingOpportunityId', 0) == fo.fundingOpportunityId
        );
        completedRFA = RFA_COMPLETED_STATUSES.includes(_.get(rfa, 'status', ''));
      }

      // Checking dates
      if (
        moment().isBetween(
          fo.aplcnStartDate,
          fo.aplcnGracePd ? fo.aplcnGracePd : fo.aplcnEndDate
        )
      ) {
        if (subAppFlag) {
          objectsToRender.push({
            id: 'startNewGrant' + index,
            displayName: fo.fundingOpportunityName,
            link:
              canStartApplication && (canStartRfa || !hasValidAssist)
                ? '/applicationInitialize/' + fo.fundingOpportunityId
                : false, // may change
            linkDisplay: canStartApplication ? 'Start application' : false,
            aplcnStartDate: fo.aplcnStartDate,
            aplcnEndDate: fo.aplcnGracePd ? fo.aplcnGracePd : fo.aplcnEndDate,
            rfaLink: canStartRfa ? rfaLocation : false,
            rfaLinkDisplay:
              fo.programId == 47
                ? 'Start request for fire management assistance'
                : 'Start request for assistance',
            subLink:
              canStartRfa ||
              (needsRfaApproval && completedRFA) ||
              (hasValidAssist && !needsRfaApproval) ||
              !hasValidAssist
                ? subAppLocation
                : false,
            subLinkDisplay: 'Start subapplication',
            programName: programName,
          });
        } else if (isNewGrantAllowedForRole) {
          objectsToRender.push({
            id: 'startNewGrant' + index,
            displayName: fo.fundingOpportunityName,
            link: '/applicationInitialize/' + fo.fundingOpportunityId, // may change
            linkDisplay: 'Start application',
            aplcnStartDate: fo.aplcnStartDate,
            aplcnEndDate: fo.aplcnGracePd ? fo.aplcnGracePd : fo.aplcnEndDate,
            subLink: false,
            programName: programName,
          });
        }
      } else if (
        (!fo.aplcnStartDate && !fo.aplcnEndDate) ||
        moment().isBefore(fo.aplcnStartDate)
      ) {
        //Supports null dates for start and end for subApps outside period
        //Check for subapp that is allowed to start outside period
        const ableToStart =
          fo.configData?.foOverview?.allowSubappsToStartOutsideOpenAppPeriod;
        //Strict check if true so
        if (subAppFlag && ableToStart === true) {
          objectsToRender.push({
            id: 'startNewGrant' + index,
            displayName: fo.fundingOpportunityName,
            link: false,
            aplcnStartDate: fo.aplcnStartDate,
            aplcnEndDate: fo.aplcnGracePd ? fo.aplcnGracePd : fo.aplcnEndDate,
            subLink: subAppLocation,
            subLinkDisplay: 'Start subapplication',
            programName: programName,
          });
        }
      }
    });

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      _.forEach(objectsToRender, (obj) => {
        if (
          _.includes(obj.programName.toLowerCase(), term) ||
          _.includes(obj.displayName.toLowerCase(), term)
        ) {
          filteredObjects.push(obj);
        }
      });
    }
    if (!_.isEmpty(filteredObjects)) {
      if (activeItem === 'Application period') {
        filteredObjects = _.sortBy(filteredObjects, 'aplcnStartDate');
        if (sortingDirection === 'Descending')
          filteredObjects = filteredObjects.reverse();
      } else if (activeItem === 'Grant program') {
        filteredObjects = _.sortBy(filteredObjects, 'programName');
        if (sortingDirection === 'Descending')
          filteredObjects = filteredObjects.reverse();
      } else {
        filteredObjects = _.sortBy(filteredObjects, 'displayName');
        if (sortingDirection === 'Descending')
          filteredObjects = filteredObjects.reverse();
      }
    } else {
      if (activeItem === 'Application period') {
        objectsToRender = _.sortBy(objectsToRender, 'aplcnStartDate');
        if (sortingDirection === 'Descending')
          objectsToRender = objectsToRender.reverse();
      } else if (activeItem === 'Grant program') {
        objectsToRender = _.sortBy(objectsToRender, 'programName');
        if (sortingDirection === 'Descending')
          objectsToRender = objectsToRender.reverse();
      } else {
        objectsToRender = _.sortBy(objectsToRender, 'displayName');
        if (sortingDirection === 'Descending')
          objectsToRender = objectsToRender.reverse();
      }
    }

    let textToRender = '';
    if (!objectsToRender.length) {
      textToRender = 'Currently there are no open application periods.';
    }

    return (
      <Grid.Column
        id="new-grant-wrapper"
        className="homepage-grid"
        width={7}
        floated="right"
      >
        <Grid.Row className="homepage">
          <h3>Apply for a new grant</h3>
        </Grid.Row>
        <Card fluid id="homepage-link">
          <Card.Content className="new-grant-content">
            {_.includes(this.props.toggles, 'fmagEnhancePt1') ? (
              <div className="search-bar-homepage">
                <form id="search-form" onSubmit={this.onSubmit}>
                  <span>
                    <Input>
                      <Input
                        title={`Search by Grant Program/Funding Opportunity Name`}
                        value={searchTerm}
                        onChange={this.handleTermChange}
                        onFocus={(e) => e.target.select()}
                        style={{width: '394px'}}
                      />
                      <Button
                        primary
                        icon
                        aria-label="Search Button"
                        title="Search button"
                      >
                        <Icon name="search" fitted />
                      </Button>
                    </Input>
                  </span>
                </form>
              </div>
            ) : (
              <></>
            )}
            <Menu borderless secondary>
              <Dropdown item text={`Sort by: ${activeItem}`} style={{'padding-left': 0}}>
                <Dropdown.Menu>
                  <Dropdown.Item
                    name="Application period"
                    active={activeItem === 'Application period'}
                    onClick={this.handleItemClick}
                  >
                    Application period
                  </Dropdown.Item>
                  <Dropdown.Item
                    name="Funding opportunity name"
                    active={activeItem === 'Funding opportunity name'}
                    onClick={this.handleItemClick}
                  >
                    Funding opportunity name
                  </Dropdown.Item>
                  {_.includes(this.props.toggles, 'fmagEnhancePt1') ? (
                    <Dropdown.Item
                      name="Grant program"
                      active={activeItem === 'Grant program'}
                      onClick={this.handleItemClick}
                    >
                      Grant program
                    </Dropdown.Item>
                  ) : (
                    <></>
                  )}
                </Dropdown.Menu>
              </Dropdown>
              <Menu.Menu position="right">
                <Radio
                  className="homepageRadioBtn"
                  name="Ascending New Grant Card"
                  value="Ascending"
                  label="Ascending (A-Z)"
                  title="Ascending"
                  checked={sortingDirection === 'Ascending'}
                  onClick={this.handleDirectionChange}
                />
                <Radio
                  className="homepageRadioBtn"
                  name="Descending New Grant Card"
                  value="Descending"
                  label="Descending (Z-A)"
                  title="Descending"
                  checked={sortingDirection === 'Descending'}
                  onClick={this.handleDirectionChange}
                />
              </Menu.Menu>
            </Menu>
            {loading ? (
              <Loader inline="centered" active>
                Loading...
              </Loader>
            ) : (
              <span style={{fontSize: '16px', color: '#565C65'}}>{textToRender}</span>
            )}
            {_.isEmpty(filteredObjects) && !searchTerm
              ? this.renderObjects(objectsToRender)
              : this.renderObjects(filteredObjects)}
          </Card.Content>
        </Card>
      </Grid.Column>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getOrgPrograms: (token) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsUnrestricted(
      token
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getProgramInfo: (token, params) => {
    const action = ApiActions.program.getProgramList(token, params);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_PROGRAM_LIST_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getSuborgOrgPrograms: (token) => {
    const action = ApiActions.organizationRelationship.getSuborgOrgPrograms(token);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_SUBORG_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplyNewGrantCardSection);
